// extracted by mini-css-extract-plugin
export default {"container":"OperationsAction_container__8oKmD","lbl":"OperationsAction_lbl__BVfMN"};